import { queryOptions } from '@tanstack/react-query';
import type {
  GenerateStreamTokenData,
  GetStreamTokenResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

export const getStreamTokenKey = () => ['getstream', 'token'] as const;

const getStreamTokenUrl: GenerateStreamTokenData['url'] =
  'integrations/getstream/token';

export const getStreamTokenOptions = <T = GetStreamTokenResponse>() =>
  queryOptions<GetStreamTokenResponse, unknown, T>({
    queryKey: getStreamTokenKey(),
    queryFn: () => PrivateApi.post(getStreamTokenUrl).json(),
    // Stream handles expired tokens, but Chat and Video will call query separately,
    // so we cache it with React Query to avoid unnecessary requests.
    staleTime: 5000,
    gcTime: 5000,
  });
